import { render, staticRenderFns } from "./ModulePermissions.vue?vue&type=template&id=75519835&scoped=true"
import script from "./ModulePermissions.vue?vue&type=script&lang=js"
export * from "./ModulePermissions.vue?vue&type=script&lang=js"
import style0 from "./ModulePermissions.vue?vue&type=style&index=0&id=75519835&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75519835",
  null
  
)

export default component.exports